'use strict';

const PROFILE_URL = 'locals';

export default ($http, $q, userModel, utils,
  currencyModel) => {
  'ngInject';

  return function (userId, tripId = null) {
    var url = PROFILE_URL + '/' + (userId || userModel.item.id);
    if (tripId) {
      url = url + '?tripId=' + tripId;
    }
    const deferred = $q.defer();
    const currency = currencyModel.getValue();
    const requestConfig = {
      params: {
        currency: currency || 'EUR'
      }
    };

    $http.get(utils.getApiUrlV2(url), requestConfig)
      .then(response => {
        const data = response.data;

        if (data.photos) {
          data.photos.sort(function (a, b) {
            return (b.main || 0) - (a.main || 0);
          });
        }
        data.$hasProfileInfo = true;
        deferred.resolve(response.data);
      })
      .catch(deferred.reject);

    return deferred.promise;
  };
};



// WEBPACK FOOTER //
// ./app/src/services/fetch_profile.js